import { handleActions } from 'redux-actions';

import openSnackbar from '../actions/openSnackbar';
import closeSnackbar from '../actions/closeSnackbar';

import handleOpenSnackbar from './handleOpenSnackbar';
import handleCloseSnackbar from './handleCloseSnackbar';

const defaultState = {
    open: false,
    message: null,
    variant: null,
    secondaryMessages: [],
};

export default handleActions(
    {
        [openSnackbar]: handleOpenSnackbar,
        [closeSnackbar]: handleCloseSnackbar,
    },
    defaultState,
);
